import { call, put, takeEvery } from "redux-saga/effects";
import { monHocApi } from "../../../api/category/monHocApi";
import { IMonHoc } from "../../../model/respone/category/IMonHoc";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eMonHocActionIds, IMonHocActionTypes } from "../../action-types/category/IMonHocActions";
import { rootActions } from "../../actions/rootActions";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
const mainAction = rootActions.category.monHoc;
export function* monHocSaga(): any {
  yield takeEvery(eMonHocActionIds.LOAD_START, loadWorker);
  yield takeEvery(eMonHocActionIds.SAVE_START, saveWorker);
  yield takeEvery(eMonHocActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(monHocApi.SelectAll);
  if (res.is_success) {
    yield put(mainAction.LOAD_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* saveWorker(action: IMonHocActionTypes): any {
  let res: IBaseRespone;//= yield call(monHocApi.SelectAll);
  const payload = action.payload as IMonHoc;
  if (payload.id_mon > 0) {
    res = yield call(monHocApi.Update, payload);
  } else {
    res = yield call(monHocApi.Insert, payload);
  }
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data));
  } else {
    yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
  }
}

function* deleteWorker(action: IMonHocActionTypes): any {
  const res: IBaseRespone = yield call(monHocApi.Deletes, action.payload as IIdsRequest);
  if (res.is_success) {
    yield put(mainAction.DELETE_SUCCESS(res.data));
  } else {
    yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
  }
}